import React from 'react';

export const ScriptContent = () => (
  <div>
    <p>
      You should insure your private home and domestic outbuildings/garages for
      their full rebuild cost and not the market value. We recommend you refer
      to scsi.ie for guidance, as rebuild costs have increased. Bank of Ireland
      is not responsible for information on third party websites
    </p>
    <p>
      If you underinsure your buildings and contents, the insurer may only pay a
      portion of any claim
    </p>
  </div>
);
